export const PAYMENT_STATUS = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  CHOOSING: 'CHOOSING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
  CANCELED: 'CANCELED',
} as const;
export const REQUEST_PAYMENT = {
  CASH: 'CASH',
  CARD: 'CARD',
  QR: 'QR',
} as const;
